import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app/download",
  "use": "app/download-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"app/download\"><path d=\"M21 20.5H3V22h18v-1.5zM18.19 12.53l-1.06-1.06-4.42 4.42V3H11.3v12.9l-4.43-4.43-1.06 1.06L12 18.72l6.19-6.19z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol